export default {
  downtimeUrl: "https://id6.kodland.tech",
  startPage: {
    image: "/welcome/quiz_turkey_new_year_steps.jpg",
    title: "Musim berbagi hadiah masih berlanjut! Penawaran khusus untuk anak Anda🎉",
    subtitle: "Semoga liburan Anda menyenangkan! Dapatkan hadiah dari kami - pelajaran gratis🎁",
    button: "Dapatkan hadiah sekarang!",
  },
  successPage: {
    title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran GRATIS 🚀",
    subtitle: "Klik tombol “📆 Pesan” dan dapatkan pelajarannya.",
    button: "📆 Pesan",
  },
  quizRotateBySteps: {
    1: {
      question: "Apakah Anda sudah menemukan hadiah yang sempurna untuk anak Anda?",
      answers: [
        "😏 Ya",
        "❌ Tidak",
        "🎁 Tidak punya waktu",
      ],
    },
    2: {
      question: "Apakah Anda ingin meningkatkan pengetahuan anak Anda di tahun mendatang?",
      answers: [
        "🥇 Ya, saya ingin",
        "👍 Anak saya berprestasi di sekolah",
        "❓ Saya belum memikirkannya.",
      ],
    },
    3: {
      question: "Keterampilan apa yang ingin Anda tingkatkan di tahun mendatang untuk anak Anda?",
      answers: [
        "🙌 Menguasai keterampilan baru yang berguna",
        "📚 Saya ingin anak memiliki keinginan untuk belajar",
        "📱 Membuat waktu penggunaan gadget menjadi produktif",
        "🎓 Saya tidak tahu, saya ingin tahu lebih banyak tentang pembelajaran ini",
      ],
    },
  },
};
